import { LOCALE_ID, NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { InternationalizationService } from '@services/i18n.service';
import { ServiceWorkerModule } from '@angular/service-worker';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
// import { SplashScreen } from '@ionic-native/splash-screen/ngx';
// import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { BrowserModule } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { StorageService } from '@services/storage.service';
import { DashboardModule } from './views/main/intranet/dashboard/dashboard.module';

registerLocaleData(localeEs);

export function getLanguage(internationalizationService: InternationalizationService) {
  return internationalizationService.getLanguage();
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        // DashboardModule,
        BrowserModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        SharedModule,
        CoreModule.forRoot(),
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    ],
    providers: [
        // { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: LOCALE_ID,
            deps: [InternationalizationService],
            useFactory: getLanguage
        },
        StorageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
